import { useCallback, useEffect, useState } from "react";
import { api, getApiError } from "@/api/client";

const identity = (value) => value;

export const useAdminData = (path, options = {}) => {
  const { enabled = true, transform = identity } = options;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError("");
    try {
      const response = await api.get(path);
      setData(transform(response.data));
    } catch (requestError) {
      setError(getApiError(requestError));
    } finally {
      setLoading(false);
    }
  }, [enabled, path, transform]);

  useEffect(() => { load(); }, [load]);
  return { data, loading, error, reload: load };
};